<template>
  <div> 
    <evaluations-list :title="'label_sideMenu_evaluations_auditReport_title'" :isReportsList="true" />
  </div>
</template>
<script >
import EvaluationsList from "../shared/EvaluationsList";

export default {
  name: "EvaluationReportList",
  components: { EvaluationsList },
};
</script >
